import React from 'react';

export default function Icon({
  icon = 'fa-phone-alt',
  variant = 'fas',
  className,
}) {
  return <span className={`${variant} ${icon} ${className}`} />;
}
